import { orchestrator } from 'satcheljs';
import {
    selectedCalendarsUpdated,
    getSelectedCalendarsFlatList,
} from 'owa-calendar-module-selected-calendars-user-config';
import { updateCalendarIds } from 'owa-calendar-events-loader';
import { isUpNextScenarioInitialized } from 'owa-upnext-event-loader';
import { getLockId } from '../selectors/getLockId';

orchestrator(selectedCalendarsUpdated, () => {
    const lockId = getLockId();
    if (isUpNextScenarioInitialized(lockId)) {
        updateCalendarIds(getSelectedCalendarsFlatList(), lockId);
    }
});
